export const sleep = (duration: number): Promise<void> => new Promise((res) => setTimeout(res, duration));
